<template>
	<footer
		class="relative mt-56 bg-neutral-200 px-14 pt-20 pb-10 dark:bg-neutral-800"
	>
		<div class="wave-top">
			<svg
				viewBox="0 0 1440 150"
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				preserveAspectRatio="none"
			>
				<path
					class="fill-white dark:fill-neutral-950"
					d="M0,15L60,27.5C120,40,240,65,360,77.5C480,90,600,90,720,80C840,70,960,50,1080,35C1200,20,1320,10,1440,22.5C1560,35,1680,70,1800,82.5C1920,95,2040,85,2160,87.5C2280,90,2400,105,2520,95C2640,85,2760,50,2880,42.5C3000,35,3120,55,3240,55C3360,55,3480,35,3600,22.5C3720,10,3840,5,3960,25C4080,45,4200,90,4320,107.5C4440,125,4560,115,4680,92.5C4800,70,4920,35,5040,37.5C5160,40,5280,80,5400,82.5C5520,85,5640,50,5760,35C5880,20,6000,25,6120,25C6240,25,6360,20,6480,37.5C6600,55,6720,95,6840,100C6960,105,7080,75,7200,65C7320,55,7440,65,7560,72.5C7680,80,7800,85,7920,85C8040,85,8160,80,8280,80C8400,80,8520,85,8580,87.5L8640,90L8640,150L8580,150C8520,150,8400,150,8280,150C8160,150,8040,150,7920,150C7800,150,7680,150,7560,150C7440,150,7320,150,7200,150C7080,150,6960,150,6840,150C6720,150,6600,150,6480,150C6360,150,6240,150,6120,150C6000,150,5880,150,5760,150C5640,150,5520,150,5400,150C5280,150,5160,150,5040,150C4920,150,4800,150,4680,150C4560,150,4440,150,4320,150C4200,150,4080,150,3960,150C3840,150,3720,150,3600,150C3480,150,3360,150,3240,150C3120,150,3000,150,2880,150C2760,150,2640,150,2520,150C2400,150,2280,150,2160,150C2040,150,1920,150,1800,150C1680,150,1560,150,1440,150C1320,150,1200,150,1080,150C960,150,840,150,720,150C600,150,480,150,360,150C240,150,120,150,60,150L0,150Z"
				></path>
			</svg>
		</div>
		<div class="container mb-10 grid grid-cols-1 gap-6 md:grid-cols-4">
			<div
				class="mb-10 flex flex-col items-center md:col-span-2 md:mb-0 md:items-start"
			>
				<h2
					class="svg-before one mt-0! w-min text-center text-4xl font-black text-neutral-900 uppercase md:text-start dark:text-white"
				>
					Propeller Festival
				</h2>
				<p class="text-center md:text-start">
					Eine Veranstaltung des BDKJ Allgäu Oberschwaben und Friedrichshafen.
				</p>
				<small class="text-darkRed text-center text-sm md:text-start">
					Mit Herz geplant von eurem Propeller Team!
				</small>
			</div>
			<div
				class="mb-10 flex flex-col items-center space-y-3 md:mb-0 md:items-start"
			>
				<h2 class="mt-0">Festival</h2>
				<NuxtLink
					class="text-fontColor hover:text-darkRed dark:hover:text-darkRed dark:text-neutral-400"
					to="/teilnahme"
				>
					AGBs
				</NuxtLink>
				<NuxtLink
					class="text-fontColor hover:text-darkRed dark:hover:text-darkRed dark:text-neutral-400"
					to="/anfahrt"
				>
					Anfahrt
				</NuxtLink>
				<NuxtLink
					class="text-fontColor hover:text-darkRed dark:hover:text-darkRed dark:text-neutral-400"
					to="/faqs"
				>
					FAQs
				</NuxtLink>
			</div>
			<div
				class="mb-10 flex flex-col items-center space-y-3 md:mb-0 md:items-start"
			>
				<h2 class="mt-0">Über uns</h2>
				<NuxtLink
					class="text-fontColor hover:text-darkRed dark:hover:text-darkRed dark:text-neutral-400"
					to="/datenschutz"
				>
					Datenschutz
				</NuxtLink>
				<NuxtLink
					class="text-fontColor hover:text-darkRed dark:hover:text-darkRed dark:text-neutral-400"
					to="/impressum"
				>
					Impressum
				</NuxtLink>
				<NuxtLink
					class="text-fontColor hover:text-darkRed dark:hover:text-darkRed dark:text-neutral-400"
					to="/kontakt"
				>
					Kontakt
				</NuxtLink>
			</div>
		</div>
		<div
			class="container flex flex-col items-center justify-between gap-3 sm:flex-row"
		>
			<div
				class="mb-6 flex flex-col items-center gap-2 sm:mb-0 sm:flex-row sm:gap-6"
			>
				<NuxtLink
					to="mailto:info@propellerfestival.de"
					target="_blank"
					class="text-fontColor hover:text-darkRed dark:hover:text-darkRed flex items-start space-x-2 dark:text-neutral-400"
				>
					<UIcon name="i-heroicons-envelope" class="size-7" />
					<label>info@propellerfestival.de</label>
				</NuxtLink>
				<NuxtLink
					to="mailto:booking@propellerfestival.de"
					target="_blank"
					class="text-fontColor hover:text-darkRed dark:hover:text-darkRed flex items-start space-x-2 dark:text-neutral-400"
				>
					<UIcon name="i-heroicons-envelope" class="size-7" />
					<label>booking@propellerfestival.de</label>
				</NuxtLink>
			</div>
			<div class="flex items-center space-x-4">
				<NuxtLink
					id="youtube"
					to="https://www.youtube.com/@jurefallgauoberschwaben4642"
					target="_blank"
					class="text-fontColor hover:text-darkRed dark:hover:text-darkRed dark:text-neutral-400"
				>
					<UIcon
						name="i-bxl-youtube"
						class="hover:text-darkestRed dark:hover:text-darkRed size-7 text-neutral-900 dark:text-neutral-100"
					/>
				</NuxtLink>
				<NuxtLink
					id="instagram"
					to="https://www.instagram.com/propellerfestival"
					target="_blank"
					class="text-fontColor hover:text-darkRed dark:hover:text-darkRed dark:text-neutral-400"
				>
					<UIcon
						name="i-bxl-instagram"
						class="hover:text-darkestRed dark:hover:text-darkRed size-7 text-neutral-900 dark:text-neutral-100"
					/>
				</NuxtLink>
			</div>
		</div>
	</footer>
</template>

<style scoped>
.svg-before {
	position: relative;
}

.svg-before::after {
	content: '';
	position: absolute;
	top: -0.2rem;
	left: -0.8rem;
	width: 2rem;
	height: 2rem;
	background-image: url('/img/hut.svg');
	background-repeat: no-repeat;
	background-size: contain;
	transform: rotate(-45deg) scaleX(-1);
}

.wave-top {
	position: absolute;
	top: -2px;
	left: 0;
	width: 100%;
	overflow: hidden;
	line-height: 0;
	transform: rotate(180deg);
}

.wave-top svg {
	position: relative;
	display: block;
	width: calc(185% + 1.3px);
	height: 80px;
	/* transform: rotateY(180deg); */
}
</style>
